import i18next from "i18next"

export const getFieldRequiredMessage = () => i18next.t("Field is required")

export const getFieldOnlyLetters = () =>
  i18next.t("Field can only contain letters")

export const getValidArabicMessage = () =>
  i18next.t("Please enter a valid Arabic name")
